import { render } from "./PrivacyPage.vue?vue&type=template&id=58600ad8&scoped=true"
const script = {}

import "./PrivacyPage.vue?vue&type=style&index=0&id=58600ad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58600ad8"]])

export default __exports__